import type { OneTrust } from './onetrust'
/**
 * Gets globalThis.window?.navigator and accepts a function that uses the navigator.
 * Handles checking if globalThis.window?.navigator is defined for you and the function will only run if globalThis.window?.navigator is defined.
 *
 * Components and functions outside of `@ecomm/shared-window` should not directly access the window object.
 */
export function getOneTrust(fn: (n: OneTrust) => void): void {
  const oneTrust = globalThis.OneTrust
  if (oneTrust) {
    fn(oneTrust)
  }
}
